import React, { useContext, useState, useEffect } from 'react';
import toast from 'react-hot-toast';

import { DataContext } from '../../init/getData';

import { Modal, Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';
import { Button, Spin } from 'antd';

import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcKindle, FcCancel, FcPlus } from "react-icons/fc";
import { FaCheck } from "react-icons/fa";
import { HiMinusCircle } from "react-icons/hi";

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import Loader from '../../components/loader/loader';

const JvInfo = (props) => {

    const { api, userData, settingData, branchData, projectData, selectedYear, currencyData } = useContext(DataContext);
    const userId = userData.id;
    const userName = userData.name;
    const userRole = userData.role.name;
    const createdBy = parseInt(userData.id);


    const { setJournalVoucher, journalVoucher, table, title, refreshTable, size, footer, idRow } = props;
    const [loadingEffect, setLoadingEffect] = useState(false);
    const [validated, setValidated] = useState(false);
    const [isSpinning, setIsSpinning] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const minDate = `${selectedYear?.label}-01-01`;
    const maxDate = `${selectedYear?.label}-12-31`;


    const today = new Date().toISOString().split('T')[0];


    // Branch Options
    const branchOptions = branchData?.map(item => ({
        value: item.id,
        label: item.name,
    }));

    // Project Options
    const projectOptions = projectData?.map(item => ({
        value: item.id,
        label: item.name,
    }))



    // Generic handler for input changes
    const handleInputChange = (e, type) => {
        let { name, value } = e.target;

        if (type == 'number') {
            value = parseFloat(value)
        } else if (type == 'boolean') {
            value = JSON.parse(value)
        }
        setJournalVoucher((prev) => ({
            ...prev,
            [name]: value,
        }));
    };


        // handle select change
        const handleSelectChange = (selectedOption, name) => {
            setJournalVoucher((prev) => ({
                ...prev,
                [name]: selectedOption?.value,
            }));
        };


    return (
        <>
            <Row className="mb-3" >

                {/* Date */}
                <Col>
                    <Form.Label className='formLabel'>Date<span style={{ color: 'red' }}> *</span></Form.Label>
                    <input
                        type="date"
                        className="form-control"
                        name="date"
                        onChange={(e) => handleInputChange(e, 'text')}
                        value={journalVoucher.date}
                        min={minDate} max={maxDate}
                        required
                    />
                </Col>

                <Col>
                    <Form.Label className='formLabel'>Reference #</Form.Label>
                    <input type="text" className="form-control" placeholder='Optional' name='refNumber'
                        onChange={(e) => handleInputChange(e, 'text')}
                        value={journalVoucher.refNumber}
                    ></input>
                </Col>
            </Row>

            <Row className="mb-3">
                <Col>
                    <Form.Label>Project</Form.Label>
                    <Select
                        options={projectOptions}
                        isClearable={true}
                        isSearchable={true}
                        placeholder="Select"
                        onChange={(e) => handleSelectChange(e, 'projectId')}
                        value={projectOptions?.find(option => option.value === journalVoucher.projectId) || []}
                    />
                </Col>


                <Col>
                    <Form.Label>Branch</Form.Label>
                    <Select
                        options={branchOptions}
                        isClearable={true}
                        isSearchable={true}
                        placeholder="Select"
                        onChange={(e) => handleSelectChange(e, 'branchId')}
                        value={branchOptions?.find(option => option.value === journalVoucher.branchId) || []}
                    />
                </Col>
            </Row>

            <Row className="mb-3" >
                <Col>
                    <Form.Label>Details</Form.Label>
                    <textarea className="form-control" rows={1}
                        value={journalVoucher.details} name='details'
                        onChange={(e) => handleInputChange(e, 'text')}
                    ></textarea>
                </Col>

            </Row>
        </>
    )
}


export default JvInfo;